import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";

const EMPTY_DATA = [];

export default function ActiveAreaChart({ data }) {
    const safeData = Array.isArray(data) ? data : EMPTY_DATA;

    // --- уникальные даты ---
    const dates = useMemo(() => {
        return Array.from(new Set(safeData.map(d => d.date))).sort();
    }, [safeData]);

    // --- уникальные типы активности ---
    const actives = useMemo(() => {
        return Array.from(new Set(safeData.map(d => d.active)));
    }, [safeData]);

    // --- подготовка series ---
    const series = useMemo(() => {
        return actives.map(active => {
            const values = dates.map(date => {
                return safeData
                    .filter(d => d.date === date && d.active === active)
                    .reduce((sum, d) => sum + (d.cnt || 0), 0);
            });

            return {
                name: active,
                type: "line",
                stack: "total",
                areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 6,
                data: values
            };
        });
    }, [dates, actives, safeData]);

    const option = {
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "line" }
        },

        legend: {
            bottom: 0
        },

        grid: {
            left: 40,
            right: 40,
            top: 24,
            bottom: 54
        },

        xAxis: {
            type: "category",
            data: dates
        },

        yAxis: {
            type: "value"
        },

        series
    };

    return (
        <ReactECharts
            option={option}
            style={{ height: 280, width: "100%" }}
        />
    );
}
